const companyHistory = () => {
    const list = document.querySelector('.pg-company-history__list');
    if (!list) return;

    const items = list.querySelectorAll('.pg-company-history__item');
    const button = document.querySelector('.pg-company-history__button');
    const VISIBLE_COUNT = 3;

    if (items.length <= VISIBLE_COUNT) {
        if (button) button.style.display = 'none';
        return;
    }

    items.forEach((item, index) => {
        if (index >= VISIBLE_COUNT) {
            item.setAttribute('data-hidden', '');
        }
    });

    if (button) {
        button.addEventListener('click', () => {
            items.forEach(item => item.removeAttribute('data-hidden'));
            button.style.display = 'none';
        });
    }
};

export default companyHistory;
